import { Button, Loading } from '@linktivity/link-ui';

import styles from './asyncState.module.css';

export interface AsyncStateProps {
  status: 'loading' | 'empty' | 'error';
  title?: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
}

const AsyncState = ({
  status,
  title,
  message,
  actionLabel,
  onAction
}: AsyncStateProps) => (
  <div
    className={styles.container}
    role={status === 'error' ? 'alert' : 'status'}
  >
    {status === 'loading' ? (
      <Loading />
    ) : (
      <>
        {title && <h2 className={styles.title}>{title}</h2>}
        {message && <p className={styles.message}>{message}</p>}
        {actionLabel && onAction && (
          <Button className={styles.action} onClick={onAction}>
            {actionLabel}
          </Button>
        )}
      </>
    )}
  </div>
);

export default AsyncState;
